import type { ReactNode } from "react";
import { InLineAlert } from "@ucl/react-library";

import type { InlineAlertVariant } from "@ucl/react-library/lib/components/inLineAlert/types";

type InlineAlertMessageProps = {
  title: string;
  body: ReactNode;
  variant?: InlineAlertVariant;
  headingLevel?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  onClose?: () => void;
};

export function InlineAlertMessage({
  title,
  body,
  variant = "error",
  headingLevel = "h2",
  onClose,
}: InlineAlertMessageProps) {
  return (
    <InLineAlert
      titleProp={{
        title,
        headingLevel,
      }}
      variant={variant}
      body={body}
      onClickClose={onClose}
    />
  );
}
